import { gql, useQuery } from "@apollo/client";
import { WBButton, WBIcon, WBTypography } from "@apptractive/design-system-web";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { PageContainer } from "../../components/PageContainer";
import { CSgetTeam as GET_TEAM } from "../../customGraphql/queries";
import { PATHS } from "../../navigation/paths";
import { TeamUsers } from "./TeamUsers";
import { Skeleton } from "@mui/material";

const Team = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { teamId } = useParams();
  const { data: teamData, loading: teamLoading } = useQuery(gql(GET_TEAM), {
    variables: {
      id: teamId,
    },
    skip: !teamId,
  });

  const team = useMemo(() => teamData?.getTeam || {}, [teamData]);

  return (
    <PageContainer>
      <WBTypography variant="h1">
        {teamLoading ? <Skeleton variant="text" width="40%" /> : team?.title}
      </WBTypography>
      <WBTypography variant="h3">
        {t("teamMembersTitle", { ns: "team" })}
      </WBTypography>
      <TeamUsers />
      <WBButton
        sx={{
          mt: 2,
          alignSelf: "flex-start",
        }}
        startIcon={<WBIcon name="Add" size="small" />}
        onClick={() => navigate(`${PATHS.team}/${teamId}/users`)}
        size="small"
        type="button"
      >
        {t("teamMemberTitle", { ns: "team" })}
      </WBButton>
    </PageContainer>
  );
};

export default Team;
